import {NgModule} from '@angular/core';
import {SharedModule} from '@shared/shared.module';
import {AuthLayoutComponent} from './auth-layout/auth-layout.component';
import {PipeModule} from '@shared/pipes/pipe.module';
import {NzLayoutModule} from 'ng-zorro-antd/layout';
import {NzMenuModule} from 'ng-zorro-antd/menu';
import {FullLayoutComponent} from './full-layout/full-layout.component';
import {LayoutComponentsModule} from './components/layout-components.module';
import {SharedComponentsModule} from '@shared/components/shared-components.module';
import {NgxsModule} from '@ngxs/store';
import {AuthState} from '@shared/state/auth/auth.state';
import {ReportState} from '@shared/state/report/report.state';
import {VehicleState} from '@shared/state/vehicle/vehicle.state';
import {BillingState} from '@shared/state/billing/billing.state';
import {AlertState} from '@shared/state/alert/alert.state';

@NgModule({
  declarations: [AuthLayoutComponent, FullLayoutComponent],
  imports: [
    SharedModule,
    PipeModule,
    NzLayoutModule,
    NzMenuModule,
    LayoutComponentsModule,
    SharedComponentsModule,
    NgxsModule.forFeature([AuthState, ReportState, VehicleState, BillingState, AlertState])
  ],
  providers: []
})
export class LayoutModule {
}
